module.exports = __webpack_public_path__ + "static/media/open_source.f373ef32.md";


//////////////////
// WEBPACK FOOTER
// ./src/views/MainView/open_source.md
// module id = 3022
// module chunks = 0